// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"397":"25e4af87","427":"feaa914a","511":"1684d4bb","644":"c48d8d8a","655":"cc594584","804":"39d64e03","868":"feaa914a"}[chunkId] + ".chunk.css";
};